<template>
  <div class="fy_view_pdf">
    <div class="view_btn">
      <img class="img-responsive" src="https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/public/btn-border.png">
      <a :href="pdfSrc[pdfIndex]" target="_blank">点击查看产品说明书</a>
    </div>
    <div class="view_btn">
      <img class="img-responsive" src="https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/public/btn-border.png">
      <a href="https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pdf/api_v2.9.0.pdf" target="_blank">点击查看API对接文档</a>
    </div>
  </div>
</template>

<script>
  import './../js/jquery.media'
  import './../assets/css/fy_view_pdf.css'
  import pdfSrc from "../assets/conf/pdfSrc"
    export default {
        name: "fy_view_pdf",
        props: ['pdfIndex'],
        data() {
            return {
                pdfSrc
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_view_pdf.vue